import { useState } from 'react';

import type { ProductTypeOptions } from '@/types/product';

import type { TaxedMoneyFragment } from '@/graphql/saleor/api';

export type Product = {
  id: string;
  objectID?: string | null | undefined;
  price: TaxedMoneyFragment;
  productTypeSlug: ProductTypeOptions;
  sku: string | null | undefined;
};
export interface AllSelectedProducts {
  products: Product[];
  totalPrice: TaxedMoneyFragment;
}

export const useAllSelectedProductsState = (
  initialState: AllSelectedProducts,
) => {
  const [allSelectedProducts, setAllSelectedProducts] =
    useState<AllSelectedProducts>(initialState);
  return { allSelectedProducts, setAllSelectedProducts };
};
